const ITEMS = [
  "Real Supply", "Verified Counterparties", "Disciplined Execution",
  "Gold Doré", "Copper Cathode", "Coltan", "Lithium", "Cassiterite",
  "Phoenix", "Kolwezi", "Kigali", "Dakar", "Dubai", "London", "Zurich", "Hong Kong",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-mono2 text-[12px] uppercase tracking-[0.35em] text-zinc-500 px-8">{t}</span>
        <span className="w-1.5 h-1.5 rotate-45 bg-[#C9A227]/60" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="hairline-t hairline-b py-5 overflow-hidden bg-[#0A0A0B]" aria-hidden="true">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
